module.exports = __webpack_public_path__ + "static/img/13.68a391d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/6/sp/13.png
// module id = XLAZ
// module chunks = 0